import LoadingIcon from "@/components/_other/icons/LoadingIcon";
import styles from "@/components/_other/button/Button.module.scss";
import Link from 'next/link';
import IconArrowRight from "@/components/_other/icons/ArrowRightIcon";
import {forwardRef} from "react";

const Button = forwardRef(({
  type = "primary",
  size = "medium",
  htmlType = "button",
  fullWidth = false,
  round= false,
  children,
  className = "",
  loading = false,
  withArrow = false,
  ...props
}, ref) => {
  if (htmlType === "a") {
    return (
      <Link
        href={props?.href}
        className={`${styles.button}
        ${styles[type]} ${styles[size]} 
        ${loading?styles.loading:""} ${props?.disabled?styles.disabled:""}
        ${fullWidth? styles.fullWidth:""} 
        ${round ? styles.round : ""} ${className}
      `}
        {...props}
      >
          {loading ? <LoadingIcon /> : children}
          {withArrow ? <IconArrowRight className="text-inherit w-[22px]-[22px] ml-3" /> : null}
      </Link>
    );
  }
  return (
    <button
      type={htmlType}
      className={`${styles.button} ${styles[type]} ${styles[size]} ${
              loading ? styles.loading : ""
            } ${props?.disabled ? styles.disabled : ""} ${
              fullWidth ? styles.fullWidth : ""
            } ${round ? styles.round : ""} ${className}`
      }
      {...props}
      disabled={loading || props?.disabled}
    >
      {loading ? <LoadingIcon className={'h-8 w-8 text-white z-10'}/> : children}
      {withArrow ? <IconArrowRight className="text-inherit w-[22px] h-[22px] ml-1" /> : null}
    </button>
  );
})

Button.displayName = "Button";

export default Button;
